// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"451ada5a","557":"c0d4401b","787":"8315a3b1"}[chunkId] + ".chunk.js";
};